/**
 * Labstep
 *
 * @module components/DeviceBooking/Form/ShowEdit/EndedAt
 * @desc EndedAt show edit for device booking
 *
 * FIXME Dead code
 */

import { getBody } from 'labstep-web/components/DeviceBooking/Form/ShowEdit/StartedAt';
import { FormShowEditDateContainer as FormShowEditDate } from 'labstep-web/core/Form/ShowEdit/Date';
import type React from 'react';
import type { DeviceBookingFormShowEditEndedAtProps } from './types';

export const DeviceBookingFormShowEditEndedAt: React.FC<
  DeviceBookingFormShowEditEndedAtProps
> = ({ deviceBooking }) => (
  <FormShowEditDate
    entity={deviceBooking}
    label="end"
    field="ended_at"
    getBody={(body) =>
      getBody(body, deviceBooking.started_at, deviceBooking.ended_at)
    }
    optimistic
    // dateTimePickerOptions={{
    //   minDate: deviceBooking.started_at,
    // }}
  />
);
